import { Star, Quote } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      quote: "RenoNovo transformed our business. We went from chasing leads to having qualified homeowners calling us. Our revenue increased 40% in the first six months.",
      author: "Mike Rodriguez",
      role: "Owner, Elite Pool Builders",
      industry: "Pool Construction",
      rating: 5,
    },
    {
      quote: "The exclusive territory model is a game-changer. I don't have to compete against other contractors for the same leads. Every appointment is mine alone.",
      author: "Sarah Chen",
      role: "CEO, Premier Kitchen & Bath",
      industry: "Kitchen Remodeling",
      rating: 5,
    },
    {
      quote: "Finally, a marketing partner that delivers what they promise. The appointments are real, the homeowners are qualified, and the ROI is exceptional.",
      author: "James Thompson",
      role: "President, Thompson Roofing",
      industry: "Roofing Services",
      rating: 5,
    },
    {
      quote: "We've tried every lead generation service out there. RenoNovo is the only one that consistently delivers quality appointments that close.",
      author: "Maria Santos",
      role: "Founder, Santos HVAC Solutions",
      industry: "HVAC",
      rating: 5,
    },
  ];

  return (
    <section className="py-20 md:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
            Success Stories
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] tracking-tight mb-6">
            Trusted by Contractors Nationwide
          </h2>
          <p className="text-lg text-[#64748b] leading-relaxed">
            See what home service professionals are saying about their partnership with RenoNovo.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.author}
              data-testid={`testimonial-${index}`}
              className="bg-[#f8fafc] p-8 rounded-sm border-l-4 border-[#2563eb] relative"
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#2563eb]/20" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#2563eb] text-[#2563eb]" />
                ))}
              </div>
              
              {/* Quote */}
              <blockquote className="text-[#0f172a] text-lg leading-relaxed mb-6">
                "{testimonial.quote}"
              </blockquote>
              
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#2563eb] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">
                    {testimonial.author.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <p className="font-bold text-[#0f172a]">{testimonial.author}</p>
                  <p className="text-sm text-[#64748b]">{testimonial.role}</p>
                  <p className="text-xs text-[#2563eb] font-medium">{testimonial.industry}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Social Proof */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 text-[#64748b]">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#2563eb] text-[#2563eb]" />
              ))}
            </div>
            <span className="font-semibold text-[#0f172a]">5.0/5</span>
            <span>average rating from 500+ contractors</span>
          </div>
        </div>
      </div>
    </section>
  );
};
